(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-gown-widget"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function showFeatureImage(e) {
      e.preventDefault();

      const gownKey = document.querySelector('.gown-widget__nav [active]')?.dataset.gown;
      const imageKey = e.currentTarget?.dataset.image;
      const imageNode = document.querySelector('.gown-widget__item[data-gown="'+gownKey+'"] .gown-widget__media img');

      if (gownKey && imageNode && images[imageKey]) {
        imageNode.setAttribute('src', images[imageKey]);
        imageNode.setAttribute('alt', e.currentTarget.textContent);
      }
    }
 
    const images = {
      'lila-1': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/lila-birth-gown-1.png?v=1668296868',
      'lila-1-zoom': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/lila-birth-gown-1-zoom.png?v=1668296868',
      'lila-2': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/lila-birth-gown-2.png?v=1668296868',
      'lila-2-zoom': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/lila-birth-gown-2-zoom.png?v=1668296868',
      'lila-3': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/lila-birth-gown-3.png?v=1668296868',
      'lila-3-zoom': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/lila-birth-gown-3-zoom.png?v=1668365945',
      'lila-4': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/lila-birth-gown-4.png?v=1668296868',
      'lila-4-zoom': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/lila-birth-gown-4-zoom.png?v=1668296868',
      'amelia-1': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/amelia-birth-gown-1.png?v=1668296868',
      'amelia-2': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/amelia-birth-gown-2.png?v=1668296868',
      'amelia-2-zoom': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/amelia-birth-gown-2-zoom.png?v=1668296868',
      'amelia-3': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/amelia-birth-gown-3.png?v=1668296867',
      'amelia-4': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/amelia-birth-gown-4.png?v=1668296868',
      'amelia-5': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/amelia-birth-gown-5.png?v=1668365945',
      'amelia-5-zoom': 'https://cdn.shopify.com/s/files/1/0595/3604/8317/files/amelia-birth-gown-5-zoomed.png?v=1702412823',
      'juliet-1': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/juliet-birth-gown-1.png?v=1668296868',
      'juliet-2': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/juliet-birth-gown-2.png?v=1668296868',
      'juliet-2-zoom': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/juliet-birth-gown-2-zoom.png?v=1668296867',
      'juliet-3': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/juliet-birth-gown-3.png?v=1668296868',
      'juliet-3-zoom': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/juliet-birth-gown-3-zoom.png?v=1668296867',
      'juliet-4': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/juliet-birth-gown-4.png?v=1668296867',
      'juliet-4-zoom': 'https://cdn.shopify.com/s/files/1/0660/9777/4842/files/juliet-birth-gown-4-zoom.png?v=1668365945',
      'nadia-1': 'https://cdn.shopify.com/s/files/1/0595/3604/8317/files/nadia-1.png?v=1696384218',
      'nadia-1-zoomed': 'https://cdn.shopify.com/s/files/1/0595/3604/8317/files/nadia-1-zoomed.png?v=1696384218',
      'nadia-2': 'https://cdn.shopify.com/s/files/1/0595/3604/8317/files/nadia-2.png?v=1697081839',
      'nadia-3-zoomed': 'https://cdn.shopify.com/s/files/1/0595/3604/8317/files/nadia-3-zoomed.png?v=1696384219',
      'nadia-4-zoomed': 'https://cdn.shopify.com/s/files/1/0595/3604/8317/files/nadia-4-zoomed.png?v=1696384218',
    }
    const featureLinks = document.querySelectorAll('.gown-widget__content li a');

    for (const link of featureLinks) {
      link.addEventListener("click", showFeatureImage);
      link.addEventListener("mouseenter", showFeatureImage);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
